module.exports = __webpack_public_path__ + "static/media/the boys edited.ab0b34cb.jpg";